angular.module('common_app').config(['$compileProvider', $compileProvider => $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|s?ftp|mailto|tel|file|weixin|whatsapp):/)]);
